import {Pipe, PipeTransform} from '@angular/core';
import {NzSafeAny} from 'ng-zorro-antd/core/types';
import {NzBytesPipe} from 'ng-zorro-antd/pipes';
import {DateFormatPipe} from '@shared/pipes/date';
import * as moment from 'moment';
import {MomentDateFormat, SysDateFormat} from '@core/constant/system.constants';
import {Utils} from '@core/utils/utils';
import {FormatCurrencyPipe} from "@shared/pipes/format-currency.pipe";
export enum MapKeyType {
  String,
  Number,
  Boolean
}

export interface MapItem {
  label: string;
  value: NzSafeAny;
}
export enum DateFormat {
  Date = 'dd/MM/yyyy',
  DateHour = 'dd/MM/yyyy HH',
  DateTime = 'dd/MM/yyyy HH:mm:ss',
}
@Pipe({
  name: 'map',
})
export class CoreMapPipe implements PipeTransform {
  private datePipe: DateFormatPipe = new DateFormatPipe();
  private bytesPipe: NzBytesPipe = new NzBytesPipe();
  private formatCurrencyPipe: FormatCurrencyPipe = new FormatCurrencyPipe();
  static transformMapToArray(data: NzSafeAny, mapKeyType: MapKeyType = MapKeyType.Number): MapItem[] {
    return Object.keys(data || {}).map(key => {
      let value: NzSafeAny;
      switch (mapKeyType) {
        case MapKeyType.Number:
          value = Number(key) ?? 0;
          break;
        case MapKeyType.Boolean:
          value = key === 'true';
          break;
        case MapKeyType.String:
        default:
          value = key;
          break;
      }
      return {value, label: data[key]};
    });
  }

  transform(value: NzSafeAny, arg?: NzSafeAny): NzSafeAny {
    if (arg === undefined) {
      return value;
    }
    let type: string = arg;
    let param = '';

    if (arg.indexOf(':') !== -1) {
      type = arg.substring(0, arg.indexOf(':'));
      param = arg.substring(arg.indexOf(':') + 1, arg.length);
    }

    switch (type) {
      case 'date':
        return this.datePipe.transform(value, param) ?? "-";
      case 'date_ddMMyyyyHHmmSS':
        param = DateFormat.DateTime;
        return this.datePipe.transform(value, param) ?? "-";
      case 'currency':
        let currency = this.formatCurrencyPipe.transform(value, param, 'symbol', '1.0-0');
        return currency  ? (currency + " VNĐ") : "-";
      case 'thousand_sep':
        let thousand_sep = this.formatCurrencyPipe.transform(value, param, 'symbol', '1.0-0');
        return thousand_sep  ? (thousand_sep) : "-";
      case 'bytes':
        return this.bytesPipe.transform(value) ?? "-";
      case 'yn':
        return (value && value == 1) ? "Có" : "Không";
      // case 'imageUrl':
      //   return (value) ? this.baseUrl + value : "";
      case 'default-blank':
        return (value) ?  value : "-";
      case 'dateTime':
        return this.datePipe.transform(value, DateFormat.DateTime) ?? "-";
      default:
        // return (this.mapObj[type] ? this.mapObj[type][value] : '');
        return "-";

    }
  }
}
